import React, { useState, useEffect } from 'react';
import EditModalWrapper from './EditModalWrapper';

const AddNoteModal = ({
    isOpen,
    onClose,
    noteData = null,
    onSave,
    isAddMode = true
}) => {
    const getNoteText = (data) => data?.content || data?.text || data?.note || '';

    const [note, setNote] = useState(getNoteText(noteData));
    const [isSubmitting, setIsSubmitting] = useState(false);
    const maxLength = 1000;

    useEffect(() => {
        if (isOpen) {
            setNote(getNoteText(noteData));
        }
    }, [isOpen, noteData]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!note.trim()) {
            alert('Please add a note');
            return;
        }

        setIsSubmitting(true);
        try {
            const noteEntry = {
                content: note.trim(),
                text: note.trim(),
                note: note.trim(),
                created_at: noteData?.created_at || new Date().toISOString(),
                updated_at: new Date().toISOString(),
            };

            await onSave(noteEntry);
            onClose();
        } catch (error) {
            console.error('Error saving note:', error);
            alert('Failed to save note. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <EditModalWrapper
            isOpen={isOpen}
            onClose={onClose}
            title={isAddMode ? "Add Note" : "Edit Note"}
            onSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            submitLabel={isAddMode ? "Add" : "Update"}
            size="md"
        >
            <div className="space-y-4">
                <div>
                    <textarea
                        value={note}
                        onChange={(e) => setNote(e.target.value.slice(0, maxLength))}
                        rows={8}
                        maxLength={maxLength}
                        className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition-all resize-none bg-white text-slate-900"
                        placeholder="Add note here"
                    />
                    <div className="text-right text-xs text-slate-400 mt-1">{maxLength - note.length}</div>
                </div>
            </div>
        </EditModalWrapper>
    );
};

export default AddNoteModal;
